import {get} from "../util/Api";
import {chartOne, chartTwo} from "../worker/worker";
import {haversineDistance} from "../util/util";
import {
    setCurrentItemLogs,
    setData,
    setCurrentItem,
    setCurrentItemLoaderLogs,
    selectDevicesCurrentCompany, updateAllDevicesSubInfo,
    setLoadData
} from "../action/page";
import {showAlertsByCurrentCompany} from "../action/alert";
import {setFilterUser} from "../action/login";

// import {hideAlerts} from "../action/alert";

// export const getDevicesByMap = params => dispatch => {
//     return new Promise((resolve, reject) => {
//         get("device", params).then(data => {
//             if (!data || !Array.isArray(data.data)) {
//                 reject(data);
//                 return;
//             }
//             let resData = data.data.map(item => {
//                 item.active = false;
//                 item.distance = item.aqi !== undefined
//                     ? haversineDistance(JSON.parse(params.center), item.location)
//                     : 100;
//                 return item;
//             });
//             resData = resData.sort((a, b) => a.distance - b.distance);
//             dispatch(setData({data: resData, state: "maps"}));

//             if (resData.length) {
//                 resData[0].active = true;
//                 dispatch(setCurrentItem({...resData[0], active: true}));
//                 // dispatch(setActiveMapData({mac: resData[0].mac}));
//             }

//             resolve(data);
//         }).catch(err => {
//             reject(err);
//         })
//     })
// }

export const getDevicesById = params => dispatch => {
    return new Promise((resolve, reject) => {
        get("device/id", params).then(data => {
            // const device = data.data;
            // const borderCenter = [
            //     [
            //         device.location[0] + 0.045,
            //         device.location[1] - 0.045
            //     ],
            //     [
            //         device.location[0] - 0.045,
            //         device.location[1] + 0.045
            //     ]
            // ];
            // dispatch(getDevicesByMap({
            //     center: JSON.stringify(device.location),
            //     coordinates: JSON.stringify(borderCenter)
            // })).then(() => {
            //     dispatch(hideAlerts());
            //     dispatch(setCurrentItem({...device, active: true}));
            //     dispatch(setActiveMapData({mac: device.mac}));
            // });

            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getAllDevicesByMap = params => (dispatch, getState) => {
    let state = getState();
    let {currentUser} = state;
    if(currentUser.user.filter.findByCompanyId && currentUser.user.companyId) {
        params = {
            companyId: currentUser.user.companyId
        }
    }
    return new Promise((resolve, reject) => {
        dispatch(setLoadData(0));
        get("device/all", params).then(data => {
            if(!data) reject();
            let resData = data.data.map(item => {
                item.active = 0;
                return item;
            })

            dispatch(setData({data: resData, state: "maps"}));
            dispatch(setLoadData(1));
            dispatch(setCurrentItem({active: false, state: "maps"}));
            let companyId = "all";
            if(window.sessionStorage.getItem("findByCompanyId") !== null){
                dispatch(setFilterUser({findByCompanyId: window.sessionStorage.getItem("findByCompanyId") === 'true'}));
                if(currentUser.user.companyId && window.sessionStorage.getItem("findByCompanyId")) {
                    companyId = currentUser.user.companyId;
                }

                dispatch(thunkSelectDevicesCurrentCompany({companyId: companyId}));
            }
            let devicesIds = ["all"];
            if(companyId !== "all") {
                const state = getState();
                devicesIds = state.page.data.reduce((acc, item) => {
                    if(item.companyId === companyId) {
                        acc.push(item._id);
                    }
                    return acc;
                }, []);
            }

            dispatch(showAlertsByCurrentCompany(devicesIds));
            if(currentUser.user.companyId) {
                dispatch(updateAllDevicesSubInfo({companyId: currentUser.user.companyId}));
            }
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

// export const getLogs = params => (dispatch, getState) => {
//     const statePrev = getState();

//     if(!params.id || statePrev.page.currentItem._id !== params.id) return;
//     dispatch(setCurrentItemLoaderLogs(true));
//     return new Promise((resolve, reject) => {
//         params.id = params.id.indexOf("__d") !== -1 ? params.id.replace("__d", ""): params.id;
//         get("getLogs", params).then(data => {
//             const state = getState();
//             const currentIdDevice = state.page.currentItem._id;

//             if(!data || data.data && data.data.length && data.data[0].deviceId !== currentIdDevice) {
//                 resolve()
//             }

//             if (data && data.status === "ok") {
//                 const result = {
//                     data: data.data,
//                     chartTwo: chartTwo(data.data),
//                     chartOne: chartOne(data.data)
//                 };
//                 dispatch(setCurrentItemLogs(result));
//                 dispatch(setCurrentItemLoaderLogs(false));
//                 resolve();
//             }
//         });
//     });
// }

export const thunkSelectDevicesCurrentCompany = data => (dispatch, getState) => {
    const {companyId} = data;
    if(companyId) {
        dispatch(selectDevicesCurrentCompany(data))
    }

    let devicesIds = ["all"];
    if(companyId !== "all") {
        const state = getState();
        devicesIds = state.page.data.reduce((acc, item) => {
            if(item.companyId === companyId) {
                acc.push(item._id);
            }
            return acc;
        }, []);
    }

    dispatch(showAlertsByCurrentCompany(devicesIds));

}

export const getDevicesByMap = params => dispatch => {
    dispatch(setLoadData(0));
    return new Promise((resolve, reject) => {
        get("device", params).then(data => {
            let resData = [];
            if(data?.data?.length) {
                resData = data.data.map(item => {
                    item.active = 0;
                    return item;
                })
            }
            dispatch(setData({data:resData, state: "maps"}));
            dispatch(setLoadData(1));
            resolve(data);
        }).catch(err => {
            reject(err);
        })
    })
}

export const getLogs = params => dispatch => {
    return new Promise((resolve, reject) => {
        get("getLogs", params).then(data => {
            if(data.status === "ok") {
                dispatch(setCurrentItemLogs(data.data));
                resolve();
            }
        });
    });
}

export const getGdacs = params => dispatch => {
    // dispatch(setLoadData(0));
    return new Promise((resolve, reject) => {
        get("gdacs", params).then(data => {
            if(data.status === "ok") {
                dispatch(setData(data));
                // dispatch(setLoadData(1))
                // dispatch(setCurrentItemLogs(data.data));
                resolve();
            }
        });
    });
}